module.exports = __webpack_public_path__ + "img/img134.1b62fa83.svg";